import { render } from "./aboutView.vue?vue&type=template&id=d4ad7872&scoped=true"
import script from "./aboutView.vue?vue&type=script&lang=js"
export * from "./aboutView.vue?vue&type=script&lang=js"

import "./aboutView.vue?vue&type=style&index=0&id=d4ad7872&scoped=true&lang=css"

import exportComponent from "C:\\Users\\krist\\Documents\\pbetoon\\pBetoon-main\\ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4ad7872"]])

export default __exports__